import GithubFinder from './github-finder.jpeg'
import HouseMarketplace from './house-marketplace.jpeg'
import SteamifyImage from './youtube.png'
import Sketchboard from './sketchboard.png'
import Propertypulse from './propertypulse.png'
import CloudStore from './cloudstore.png'

export const uiPics = {
  GithubFinder,
  HouseMarketplace,
  SteamifyImage,
  Sketchboard,
  Propertypulse,
  CloudStore,

}
